var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.layout !== null)?_c(_vm.layout,{tag:"component",attrs:{"id":"app"}},[_c('router-view')],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }